'use client'

import { useEffect, useState } from 'react'
import type { MutableRefObject } from 'react'

export function useInViewport<T extends Element>(
    ref: MutableRefObject<T>,
    threshold = 0.0, // only single value, @see: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#threshold
): boolean {
    const [isIntersecting, setIntersecting] = useState<boolean>(false)

    useEffect(() => {
        let observerRefValue: T | null = null

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIntersecting(entry.isIntersecting)
            },
            {
                threshold,
            },
        )

        if (ref.current) {
            observer.observe(ref.current)
            observerRefValue = ref.current
        }

        return () => {
            if (observerRefValue) {
                observer.unobserve(observerRefValue)
            }
        }
    }, [ref, threshold])

    return isIntersecting
}
